import gsap from 'gsap';
import Headroom from 'headroom.js';
import { Quart, Sine, Quint, Circ } from 'gsap/gsap-core';
import $ from '../core/Dom';
import Viewport from '../core/Viewport';

export default el => {
    const dom = $(el);
    const html = $('html');
    const body = $('body');
    const menuButton = dom.find('[data-menu-toggle]');
    const menu = dom.find('[data-menu]').get(0);
    const header = dom.find('[data-header]').get(0);

    let menuOpen = false;
    let headroom = null;

    const onBodyKeyUp = e => {
        const key = e.key || e.keyCode || e.which || null;
        if (['Escape', 27].indexOf(key) > -1) {
            toggleMenu();
        }
    };

    const openMenu = () => {
        html.addClass('js-menu-open');
        body.on('keyup', onBodyKeyUp);
        gsap.killTweensOf([menu]);
        gsap.to(menu, { duration: 0.5, autoAlpha: 1, ease: Quint.easeInOut });
        if (headroom) {
            headroom.freeze();
        }
    };

    const closeMenu = () => {
        html.removeClass('js-menu-open');
        body.off('keyup', onBodyKeyUp);
        gsap.killTweensOf([menu]);
        gsap.to(menu, { duration: 0.35, autoAlpha: 0, ease: Sine.easeInOut });
        if (headroom) {
            headroom.unfreeze();
        }
    };

    const toggleMenu = () => {
        if (menuOpen) {
            closeMenu();
        } else {
            openMenu();
        }
        menuOpen = !menuOpen;
    };

    const initHeadroom = () => {
        if (!headroom) {
            headroom = new Headroom(header, {
                tolerance: 5
            });
            headroom.init();
            headroom.pin();
            $(header).on('focusin', () => {
                headroom.pin();
            });
        }
    };

    const destroyHeadroom = () => {
        if (headroom) {
            headroom.destroy();
            headroom = null;
            $(header).off('focuswithin');
        }
    };

    const onResize = () => {
        const diff = document.body.scrollHeight - window.innerHeight;

        if (!headroom && diff >= 10) {
            initHeadroom();
        } else if (headroom && diff < 10) {
            destroyHeadroom();
        }
    };

    const init = () => {
        menuButton.on('click', e => {
            e.preventDefault();
            toggleMenu();
        });
        Viewport.on('resize', onResize);
        onResize();
    };

    const destroy = () => {
        destroyHeadroom();
        menuButton.off('click');
        Viewport.off('resize', onResize);
    };

    return {
        init,
        destroy
    };
};
